import React from 'react'
import PropTypes from 'prop-types'
import ThemeText from 'cms/CmsText'

const Text = ({
  content: {
    text = {},
  },
  style,
  settings,
  currentLang,
  renderElement,
}) => (
  renderElement(
    ThemeText,
    {
      style,
      ...settings,
      children: text[currentLang],
    },
  )
)

Text.propTypes = {}
Text.defaultProps = {}

export default Text



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/text/Text.js